import { Category } from "./types";

export const addParentReferences = (
  category: Category,
  parent?: Category
): Category => {
  const categoryWithParent = { ...category, parent };
  if (category.children) {
    categoryWithParent.children = category.children.map((child) =>
      addParentReferences(child, categoryWithParent)
    );
  }
  return categoryWithParent;
};

export const findCategoryById = (
  categories: Category[],
  targetId: string
): Category | null => {
  for (const category of categories) {
    if (category.id === targetId) {
      return category;
    }
    if (category.children) {
      const found = findCategoryById(category.children, targetId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const findCategoryPath = (
  categoryId: string,
  categories: Category
): Category[] => {
  const path: Category[] = [];
  const allCategories = flattenCategories(categories);
  const category = findCategoryById(allCategories, categoryId);

  if (!category) return path;

  let current: Category | undefined = category;
  while (current) {
    path.unshift(current);
    current = current.parent;
  }

  return path.slice(0, -1); // Remove the root category from the path
};

export const flattenCategories = (category: Category): Category[] => {
  let result: Category[] = [category];
  if (category.children) {
    category.children.forEach((child) => {
      result = result.concat(flattenCategories(child));
    });
  }
  return result;
};
